import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import './Reviews.css';

const Reviews = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Review images from the Reviews folder
  const reviewImages = [
    {
      id: 1,
      src: require('../assets/images/Evening+Standard.jpeg'),
      title: "Evening Standard Review",
      alt: "Evening Standard Review"
    },
    {
      id: 2,
      src: require('../assets/images/Review.jpeg'),
      title: "perceptivetravel.com",
      alt: "Perceptive Travel Review"
    },
    {
      id: 3,
      src: require('../assets/images/image-asset.jpeg'),
      title: "Songlines Magazine",
      alt: "Songlines Magazine Review"
    }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="reviews-page">
      <Navigation />
      
      <div className="reviews-content">
        <h1 className="page-title">REVIEWS</h1>
        
        <div className="reviews-gallery">
          {reviewImages.map((image) => (
            <div 
              key={image.id}
              className="review-item"
              onClick={() => openModal(image)}
            >
              <img 
                src={image.src} 
                alt={image.alt}
                className="review-image"
              />
              <div className="review-overlay">
                <span className="review-title">{image.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for enlarged image */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>×</button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="modal-image"
            />
            <div className="modal-title">{selectedImage.title}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reviews;